import _ from "lodash";
import { User } from "../../../gateway/User/User";
import { MixPanelAdapter } from "../../adpters/MixPanelAdapter/MixPanelAdapter";
import { UserDataAdapter } from "../../adpters/UserDataAdapter";
import { LocalStoreService } from "../LocalStoreService";

export class Events {
    constructor() {
        this.User = new User();
        this.LocalStoreService = new LocalStoreService();
        this.MixPanelAdapter = new MixPanelAdapter();
    }

    setParamns(parans) {
        this.params = parans;
        this.MixPanelAdapter.setParamns(parans);
    }

    send(eventName, user = false) {
        console.log(
            eventName
                ?.normalize("NFD")
                ?.replace(/[\u0300-\u036f]/g, "")
                ?.toLowerCase()
        );

        if (publicSettings.environment != "production") {
            return false;
        }
        try {
            this.user = user ? user : new UserDataAdapter().user();
            if (this.user) {
                this.MixPanelAdapter.setUser(this.user);
                this.accountingUsers = [
                    "Contabilidade",
                    "ContabilidadeTrial",
                    "ContabilidadeTrialPro",
                    "Contabil",
                    "Comercial",
                    "Fiscal",
                    "Pessoal",
                    "Empresa",
                    "Financeiro",
                    "Gestor",
                    "Pessoal e Fiscal",
                    "Anonimo"
                ];
                const hasPermission = this.User.checkPermission({
                    roles: _.get(this.user, "roles"),
                    granted: this.accountingUsers
                });
                const params = this.getParams();
                if (hasPermission || this.user?.profile?.isAnonimo) {
                    this.MixPanelAdapter.event(eventName, params);
                    return true;
                } else {
                    this.MixPanelAdapter.event(
                        `internaluser.${eventName}`,
                        params
                    );
                    return false;
                }
            }
        } catch (error) {
            console.error("Events", error);
        }
    }

    getParams() {
        const company = this.LocalStoreService.getItem("company");
        const accounting = this.LocalStoreService.getItem("accounting");
        const params = {
            ...accounting,
            ...company,
            accountingName: accounting?.name,
            accountingId: this.user?.profile?.accountingId || accounting?._id
        };
        delete params.name;
        if (company?._id) {
            params.companyName = company?.name;
            params.companyId = company?._id;
        }
    }
}
